import PlayerWalletActionType from 'actions/playerWallet/playerWalletActionType';

const initialState = {
  walletHistory: {},
  walletHistoryV2: {},
  walletsInfo: {},
  walletsInfoV2: {},
  isPlayerWalletsInfoChanged: false,
  extraWallets: null,
  extraWalletsLoading: false,
  isPlayerExtraWalletsChanged: false,
  csvPlayers: [],
};

const playerWalletReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case PlayerWalletActionType.SAVE_PLAYER_WALLET_HISTORY:
    return {
      ...state,
      walletHistory: payload.data,
    };
  case PlayerWalletActionType.RESET_PLAYER_WALLET_HISTORY:
    return {
      ...state,
      walletHistory: {},
    };
  case PlayerWalletActionType.SAVE_PLAYER_WALLET_HISTORY_V2:
    return {
      ...state,
      walletHistoryV2: payload.data,
    };
  case PlayerWalletActionType.RESET_PLAYER_WALLET_HISTORY_V2:
    return {
      ...state,
      walletHistoryV2: {},
    };
  case PlayerWalletActionType.SAVE_PLAYER_WALLETS_INFO:
    return {
      ...state,
      walletsInfo: payload.data,
    };
  case PlayerWalletActionType.RESET_PLAYER_WALLETS_INFO:
    return {
      ...state,
      walletsInfo: {},
    };
  case PlayerWalletActionType.SAVE_PLAYER_WALLETS_INFO_V2:
    return {
      ...state,
      walletsInfoV2: payload.data,
    };
  case PlayerWalletActionType.RESET_PLAYER_WALLETS_INFO_V2:
    return {
      ...state,
      walletsInfoV2: {},
    };
  case PlayerWalletActionType.CHANGE_PLAYER_WALLETS_INFO_UPDATED_STATUS:
    return {
      ...state,
      isPlayerWalletsInfoChanged: payload.status,
    };
  case PlayerWalletActionType.SAVE_PLAYER_EXTRA_WALLETS:
    return {
      ...state,
      extraWallets: payload.data,
    };
  case PlayerWalletActionType.RESET_PLAYER_EXTRA_WALLETS:
    return {
      ...state,
      extraWallets: null,
    };
  case PlayerWalletActionType.CHANGE_PLAYER_EXTRA_WALLETS_UPDATED_STATUS:
    return {
      ...state,
      isPlayerExtraWalletsChanged: payload.status,
    };
  case PlayerWalletActionType.PLAYER_EXTRA_WALLETS_LOADING:
    return {
      ...state,
      extraWalletsLoading: payload.state,
    };
  default:
    return state;
  }
};

export default playerWalletReducer;
